import { Validator } from 'vee-validate'

Validator.extend('truly', {
  getMessage: field => 'The ' + field + ' value is not truly.',
  validate: value => !!value
})